import React, { useState, useEffect } from 'react';
import ItemTable from "./ItemTable";
import MissingCows from "./MissingCows";
import {
  Box,
  Button,
} from '@mui/material';

const MainComponent = () => {
  const [currentTab, setCurrentTab] = useState('A');

  const renderComponent = () => {
    if (currentTab === 'A') {
      return <MissingCows />;
    }
    if (currentTab === 'B') {
      return <ItemTable />;
    }
  };

  return (
    <div>
      {/* Gombok fixen a tetején */}
      <Box display="flex" justifyContent="center" borderBottom="1px solid #ddd" position="sticky" top={0} bgcolor="white" zIndex={1000}>
        <Button
          onClick={() => setCurrentTab('A')}
          variant={currentTab === 'A' ? 'contained' : 'outlined'}
          color="primary"
          style={{ margin: '10px' }}
        >
          Hiányzó tehenek
        </Button>
        <Button
          onClick={() => setCurrentTab('B')}
          variant={currentTab === 'B' ? 'contained' : 'outlined'}
          color="primary"
          style={{ margin: '10px' }}
        >
          Listázás
        </Button>
      </Box>

      {/* A kiválasztott komponens megjelenítése */}
      <Box padding="20px">
        {renderComponent()}
      </Box>
    </div>
  );
};

export default MainComponent;